import * as React from "react";
const SvgWanx = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "#240646" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.9379 5.95679C14.3388 5.89006 14.7295 4.80437 14.7593 4.14224C14.7628 4.06445 14.8248 4 14.9027 4C14.9786 4 15.0398 4.06202 15.0431 4.13789C15.1067 5.61085 16.1909 5.96814 16.8544 5.9665C16.933 5.96631 17.0002 6.02769 17.0002 6.10626C17.0002 6.18014 16.9399 6.23968 16.8661 6.24299C15.4382 6.30695 15.058 7.39343 15.0386 8.05659C15.0363 8.13467 14.9745 8.20005 14.8964 8.20005C14.8212 8.20005 14.7605 8.13873 14.757 8.06356C14.6908 6.66167 13.6047 6.27067 12.9424 6.24088C12.8646 6.23738 12.8001 6.17539 12.8001 6.09753C12.8001 6.02159 12.862 5.96041 12.9379 5.95679Z",
      fill: "#FF2A7C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.03003 7.01025H3.14C3.06268 7.01025 3 7.07228 3 7.1496V12.1203C3 13.6953 4.54002 15.6204 6.64004 15.6204C8.12892 15.6204 9.01303 15.0523 9.36547 14.6712C9.42643 14.6053 9.53354 14.5979 9.5989 14.6594C10.4386 15.4501 11.648 15.6315 12.1701 15.6204C15.1101 15.6204 15.9152 13.287 15.9502 12.1203V8.33706C15.9502 8.26151 15.8889 8.20027 15.8134 8.20027C15.7676 8.20027 15.7252 8.22323 15.6982 8.26012C15.5363 8.4809 15.2066 8.83028 14.9001 8.83028C14.5866 8.83028 14.208 8.46452 14.0261 8.24499C14.003 8.21706 13.9689 8.20027 13.9327 8.20027C13.8677 8.20027 13.8151 8.25289 13.8151 8.31779V12.1203C13.7918 12.587 13.4301 13.5203 12.1701 13.5203C10.9101 13.5203 10.5718 12.587 10.5601 12.1203V7.15026C10.5601 7.07293 10.4974 7.01025 10.4201 7.01025H8.56507C8.48775 7.01025 8.42507 7.07293 8.42507 7.15026V12.1203C8.4134 12.587 8.06806 13.5203 6.78005 13.5203C5.49203 13.5203 5.17003 12.587 5.17003 12.1203V7.15026C5.17003 7.07293 5.10735 7.01025 5.03003 7.01025Z",
      fill: "white"
    }
  )
);
export default SvgWanx;
